import React, { useState, useContext } from 'react';

interface Error {
  errorCode?: number
  message?: string
  resolve?: {}
}

interface ErrorContext {
  error: Error | null
  setError: React.Dispatch<any>
}

const ErrorContext = React.createContext<ErrorContext>({
  error: null,
  setError: () => {}
});

interface ErrorProviderProps extends ErrorContext {
  children: React.ReactNode
}

export const ErrorProvider = ({ error: initialError, children }: ErrorProviderProps) => {
  const [error, setError] = useState(initialError);
  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => useContext(ErrorContext);

export default ErrorContext;
